export default __webpack_public_path__ + "static/media/5.4b91b2fb.jpg";